export enum PassAutomatedProfiles {
    Both = 0,
    Microsite = 1,
    RecipientProfile = 2
}